import React from "react";
import { useForm, Controller, watch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid, Card, Typography } from "@mui/material";
import { Select, Button } from "antd";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const { Option } = Select;

// 🔥 Validation Schema
const schema = yup.object().shape({
  type: yup.string().required("Assignment type is required"),
  users: yup.array().when("type", {
    is: (val) => val === "team" || val === "individual",
    then: (schema) => schema.min(1, "Please select at least one"),
  }),
});

const index = () => {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "all",
      users: [],
    },
    resolver: yupResolver(schema),
  });

  const selectedType = watch("type");

  // Dummy data
  const teamList = ["Team A", "Team B"];
  const userList = ["Anupam", "Rahul", "John"];

  const onSubmit = (data, actionType) => {
    console.log(actionType, data);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Typography variant="h4" fontWeight="bold">
          Assignment 
        </Typography>
      </MDBox>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card
            style={{
              padding: 24,
              borderRadius: 16,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            }}
          >
            {/* Header */}
            {/* <MDBox mb={3}>
              <Typography variant="h6" fontWeight="600">
                Assignment Configuration
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Manage assignments, pull back or clean unassigned data
              </Typography>
            </MDBox> */}

            {/* Form Section */}
            <Grid container spacing={2}>
              {/* Assignment Type */}
              <Grid item xs={12} md={6}>
                <Typography variant="caption">Assignment Type</Typography>
                <Controller
                  name="type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      style={{ width: "100%", marginTop: 6 }}
                      size="large"
                      onChange={(val) => field.onChange(val)}
                    >
                      <Option value="all">All</Option>
                      <Option value="team">Team</Option>
                      <Option value="individual">Individual</Option>
                    </Select>
                  )}
                />
              </Grid>

              {/* Conditional Dropdown */}
              {(selectedType === "team" || selectedType === "individual") && (
                <Grid item xs={12} md={6}>
                  <Typography variant="caption">
                    {selectedType === "team" ? "Select Team" : "Select Users"}
                  </Typography>

                  <Controller
                    name="users"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        mode="multiple"
                        size="large"
                        style={{ width: "100%", marginTop: 6 }}
                        placeholder="Select..."
                        onChange={(val) => field.onChange(val)}
                      >
                        {(selectedType === "team" ? teamList : userList).map((item) => (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                </Grid>
              )}
            </Grid>

            {/* Divider */}
            <MDBox mt={4} mb={2} borderTop="1px solid #eee" />

            {/* Action Buttons */}
            <MDBox display="flex" justifyContent="flex-end" gap={2} flexWrap="wrap">
              <Button
                type="primary"
                size="large"
                onClick={handleSubmit((data) => onSubmit(data, "pullback"))}
              >
                Pull Back
              </Button>

              <Button danger size="large" onClick={handleSubmit((data) => onSubmit(data, "clean"))}>
                Clean Unassigned Data
              </Button>

              <Button size="large" onClick={() => reset()}>
                Reset
              </Button>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default index;
